const CommonConstants = class {
    static GuidEmpty: string = '00000000-0000-0000-0000-000000000000';
}

export { CommonConstants };